// extracted by mini-css-extract-plugin
export default {"main":"CopyButton_main__fWihb","copyIcon":"CopyButton_copyIcon__bZE8Z","copiedPopup":"CopyButton_copiedPopup__-g2wG"};